import { render, staticRenderFns } from "./dispatcher-list-row.vue?vue&type=template&id=d2760f88"
import script from "./dispatcher-list-row.vue?vue&type=script&lang=js"
export * from "./dispatcher-list-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports